import { Component, OnInit } from '@angular/core';
import { RouteTrackerService } from './Services/route-tracker.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent implements OnInit {
  title = 'app';

  constructor(private routeTracker: RouteTrackerService) {
    // The route tracker service will handle all page navigation events
  }

  ngOnInit() {
    // App component initialization
  }
}



// WEBPACK FOOTER //
// /Users/mowebdevice/Desktop/Web Project/angular-scrubup/src/app/app.component.ts